import { render, staticRenderFns } from "./remove-bank-account.component.vue?vue&type=template&id=f10a831a&"
import script from "./remove-bank-account.component.vue?vue&type=script&lang=ts&"
export * from "./remove-bank-account.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports